import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// 导入页面组件（自 App.js 原样迁出，保持原导入顺序）
import Dashboard from '../pages/Dashboard';
import HomePage from '../pages/HomePage'; // 新增：手机端首页组件
import AdminPanel from '../pages/AdminPanel';
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import History from '../pages/History';
import CoordinateTool from '../pages/CoordinateTool';
import ToolsPage from '../pages/ToolsPage';
import TrackerSetupPage from '../pages/TrackerSetupPage';
import TrackerBindPage from '../pages/TrackerBindPage';
import PickPointPage from '../pages/PickPointPage';
import PickPointShareRedirect from '../pages/PickPointShareRedirect';
import RescuePush from '../pages/RescuePush';
import Settings from '../pages/Settings';
import Devices from '../pages/Devices';
import MultiWindowLive from '../pages/MultiWindowLive';
import UserCenter from '../pages/UserCenter';
import ProtectedRoute from './ProtectedRoute';

/** 路由表（自 App.js 原样迁出，路径/守卫/重定向均不变） */
export default function AppRoutes() {
  return (
    <Routes>
      {/* 首页 - 根据设备类型显示不同内容 */}
      <Route path="/" element={<HomePage />} />
      
      {/* 指挥系统 - 需登录，未登录不可见也不可进 */}
      <Route path="/command" element={
        <ProtectedRoute perm="指挥系统页面" allowGuest={false}>
          <Dashboard />
        </ProtectedRoute>
      } />
      
      {/* 兼容旧路由，重定向到新路由 */}
      <Route path="/dashboard" element={<Navigate to="/command" replace />} />
      
      {/* 管理后台 */}
      <Route path="/admin" element={<AdminPanel />} />
      
      {/* 用户认证 */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      
      {/* 用户中心 */}
      <Route path="/user" element={
        <ProtectedRoute perm="用户中心">
          <UserCenter />
        </ProtectedRoute>
      } />
      
      {/* 功能页面 */}
      <Route path="/tools" element={
        <ProtectedRoute perm="工具下载" allowGuest={true}>
          <ToolsPage />
        </ProtectedRoute>
      } />
      <Route path="/coordinate" element={
        <ProtectedRoute perm="坐标转换" allowGuest={true}>
          <CoordinateTool />
        </ProtectedRoute>
      } />
      <Route path="/history" element={
        <ProtectedRoute perm="轨迹查询">
          <History />
        </ProtectedRoute>
      } />
      <Route path="/rescue" element={
        <ProtectedRoute perm="救援推送">
          <RescuePush />
        </ProtectedRoute>
      } />
      <Route path="/m/tracker" element={<TrackerBindPage />} />
      <Route path="/m/pick" element={<PickPointPage />} />
      <Route path="/p/:code" element={<PickPointShareRedirect />} />
      <Route path="/live" element={
        <ProtectedRoute perm="多窗口直播监控">
          <MultiWindowLive />
        </ProtectedRoute>
      } />
      <Route path="/devices" element={
        <ProtectedRoute perm="设备管理">
          <Devices />
        </ProtectedRoute>
      } />
      
      {/* 兼容旧路由的重定向 */}
      <Route path="/setup-tracking" element={<Navigate to="/tools" replace />} />
      <Route path="/settings" element={<Navigate to="/admin" replace />} />
      <Route path="/rescue-push" element={<Navigate to="/rescue" replace />} />
      <Route path="/multi-window-live" element={<Navigate to="/live" replace />} />
      
      {/* 404 处理 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
